import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { UserGroupPageRoutingModule } from './user-group-routing.module';

import { UserGroupPage } from './user-group.page';
import { UserGroupDetailsComponent } from './user-group-details/user-group-details.component';
import { SharedModule } from '../shared/shared.module';
import { UpdateUserGroupComponent } from './update-user-group/update-user-group.component';
import { AddUserGroupComponent } from './add-user-group/add-user-group.component';
import { UserGroupFilterComponent } from './user-group-filter/user-group-filter.component';
import { AddGroupFilterComponent } from './add-group-filter/add-group-filter.component';
import { UpdateGroupFilterComponent } from './update-group-filter/update-group-filter.component';
import { GroupFilterDetailsComponent } from './group-filter-details/group-filter-details.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    UserGroupPageRoutingModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
  ],
  declarations: [
    UserGroupPage, 
    AddUserGroupComponent, 
    UserGroupDetailsComponent, 
    UpdateUserGroupComponent,
    UserGroupFilterComponent, 
    AddGroupFilterComponent, 
    UpdateGroupFilterComponent,
    GroupFilterDetailsComponent
  ],
  providers:[DatePipe]
})
export class UserGroupPageModule {}
